import React from "react";

function EmdText({ label }) {
  return <p className="bottomStyle">{label}</p>;
}

export default EmdText;
